import type { ChartBlock } from "../../../shared/chords";
import { CHART_MODES, toNashville, type ChartMode } from "../songs/music-theory";
import "./chart.css";

export { CHART_MODES, type ChartMode };

function chordText(symbol: string | null, mode: ChartMode, numberKey: string): string {
  if (!symbol || mode === "lyrics") return "";
  return mode === "numbers" ? toNashville(symbol, numberKey) : symbol;
}

export function ChartView({ blocks, mode = "stacked", numberKey = "C" }: { blocks: ChartBlock[]; mode?: ChartMode; numberKey?: string }) {
  return (
    <div className={`chart mode-${mode}`}>
      {blocks.map((block, index) => {
        if (block.type === "spacer") return <div className="chart-gap" key={index} />;
        if (block.type === "section") return <h3 className="chart-section" key={index}>{block.label}</h3>;
        if (block.type === "text") return <p className="chart-note" key={index}>{block.text}</p>;
        if (block.type === "chords") {
          if (mode === "lyrics") return null;
          const chords = block.chords.map((symbol) => chordText(symbol, mode, numberKey));
          return <p className="chart-chords" key={index}>{chords.join("   ")}</p>;
        }
        if (mode === "chords") {
          const chords = block.parts.map((part) => chordText(part.chord, mode, numberKey)).filter(Boolean);
          return chords.length > 0 ? <p className="chart-chords" key={index}>{chords.join("   ")}</p> : <div className="chart-gap" key={index} />;
        }
        if (mode === "inline") {
          const line = block.parts.map((part) => `${part.chord ? `(${chordText(part.chord, mode, numberKey)}) ` : ""}${part.lyric}`).join("");
          return <p className="chart-inline" key={index}>{line || " "}</p>;
        }
        return (
          <p className="chart-line" key={index}>
            {block.parts.map((part, partIndex) => (
              <span className="cell" key={partIndex}>
                <i>{chordText(part.chord, mode, numberKey)}</i>
                <b>{part.lyric || " "}</b>
              </span>
            ))}
          </p>
        );
      })}
    </div>
  );
}
